<!-- ================= HEADER ================= -->
<div class="label-bar">
  <button mat-icon-button (click)="back.emit()">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <label class="textColour" style="font-size:18px;font-weight:500;">
    {{ headerTitle }}
  </label>

  <span class="example-spacer"></span>

  <!-- ===== NEW / DRAFT ===== -->
  <ng-container *ngIf="showDraftActions && !isViewOnly">
    <app-common-button
      label="Save Draft"
      title="Save Draft"
      icon="fas fa-save"
      [buttonId]="1111"
      width="120px"
      (clicked)="onSaveDraft()"
      style="margin-right:1%">
    </app-common-button>

    <app-common-button
      label="Submit"
      title="Submit"
      icon="fas fa-paper-plane"
      [buttonId]="1111"
      width="120px"
      (clicked)="onStartProgress()">
    </app-common-button>
  </ng-container>

  <!-- ===== IN PROGRESS ===== -->
  <ng-container *ngIf="showInProgressActions && !isViewOnly">
    <app-common-button
      label="Save Changes"
      title="Save Changes"
      icon="fas fa-save"
      [buttonId]="1111"
      width="120px"
      (clicked)="onSaveChanges()"
      style="margin-right:1%">
    </app-common-button>

    <app-common-button
      label="Cancel Request"
      title="Cancel Request"
      icon="fas fa-times-circle"
      [buttonId]="1111"
      width="120px"
      (clicked)="onCancelRequest()"
      style="margin-right:1%">
    </app-common-button>

    <app-common-button
      label="Complete"
      title="Complete"
      icon="fas fa-check-circle"
      [buttonId]="1111"
      width="120px"
      (clicked)="onCompleteRequest()">
    </app-common-button>
  </ng-container>
</div>

<!-- ================= TABS ================= -->
<mat-tab-group class="tabs" [(selectedIndex)]="selectedTab" mat-stretch-tabs="false">

  <!-- ================= REQUEST DETAILS ================= -->
  <mat-tab label="Request Details">
    <div class="card">
      <label class="textColour" style="margin-top:1%;">Request Information</label>

      <form [formGroup]="form" class="form-grid">
        <!-- Source -->
        <mat-form-field appearance="outline">
          <mat-label>Source (Authority)</mat-label>
          <mat-select formControlName="source" [disabled]="isViewOnly">
            <mat-option value="FDA">FDA</mat-option>
            <mat-option value="EMA">EMA</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('source')?.hasError('required')">
            Source is required
          </mat-error>
        </mat-form-field>

        <!-- Issue Date -->
        <mat-form-field appearance="outline">
          <mat-label>Issue Date</mat-label>
          <input matInput [matDatepicker]="issue" formControlName="issueDate" [disabled]="isViewOnly">
          <mat-datepicker-toggle matSuffix [for]="issue"></mat-datepicker-toggle>
          <mat-datepicker #issue></mat-datepicker>
          <mat-error *ngIf="form.get('issueDate')?.hasError('required')">
            Issue Date is required
          </mat-error>
        </mat-form-field>

        <!-- HA Due Date -->
        <mat-form-field appearance="outline">
          <mat-label>HA Due Date</mat-label>
          <input matInput [matDatepicker]="due" formControlName="dueDate" [disabled]="isViewOnly">
          <mat-datepicker-toggle matSuffix [for]="due"></mat-datepicker-toggle>
          <mat-datepicker #due></mat-datepicker>
          <mat-error *ngIf="form.get('dueDate')?.hasError('required')">
           HA Due Date is required
          </mat-error>
        </mat-form-field>

        <!-- Subject -->
        <mat-form-field appearance="outline" class="full">
          <mat-label>Subject</mat-label>
          <input matInput formControlName="subject" [disabled]="isViewOnly">
          <mat-error *ngIf="form.get('subject')?.hasError('required')">
            Subject is required
          </mat-error>
        </mat-form-field>

        <!-- Product Name -->
        <mat-form-field appearance="outline">
          <mat-label>Product Name</mat-label>
          <input matInput formControlName="productName" [disabled]="isViewOnly">
          <mat-error *ngIf="form.get('productName')?.hasError('required')">
            Product Name is required
          </mat-error>
        </mat-form-field>

        <!-- INN -->
        <mat-form-field appearance="outline">
          <mat-label>INN</mat-label>
          <input matInput formControlName="inn" [disabled]="isViewOnly">
          <mat-error *ngIf="form.get('inn')?.hasError('required')">
            INN is required
          </mat-error>
        </mat-form-field>

        <!-- Product Type -->
        <mat-form-field appearance="outline">
          <mat-label>Product Type</mat-label>
          <mat-select formControlName="productType" [disabled]="isViewOnly">
            <mat-option value="Drug">Drug</mat-option>
            <mat-option value="Device">Device</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('productType')?.hasError('required')">
            Product Type is required
          </mat-error>
        </mat-form-field>

        <!-- Product Status -->
        <mat-form-field appearance="outline">
          <mat-label>Product Status</mat-label>
          <mat-select formControlName="productStatus" [disabled]="isViewOnly">
            <mat-option value="Approved">Approved</mat-option>
            <mat-option value="Pre-Approved">Pre-Approved</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('productStatus')?.hasError('required')">
            Product Status is required
          </mat-error>
        </mat-form-field>

        <!-- External Tracking ID -->
        <mat-form-field appearance="outline">
          <mat-label>External Tracking ID</mat-label>
          <input matInput formControlName="externalTrackingId" placeholder="If applicable" [disabled]="isViewOnly">
        </mat-form-field>

        <!-- Description -->
        <mat-form-field appearance="outline" class="full">
          <mat-label>Description</mat-label>
          <textarea matInput rows="4" formControlName="description" [disabled]="isViewOnly"></textarea>
          <mat-error *ngIf="form.get('description')?.hasError('required')">
            Description is required
          </mat-error>
        </mat-form-field>
      </form>
    </div>
  </mat-tab>

  <!-- ================= SUB-ACTIONS ================= -->
  <mat-tab label="Sub-Actions">
    <div class="card">

      <!-- SUMMARY -->
      <div class="subaction-summary">
        <span>Total: {{ subActions.length }}</span>
        <span>Pending: {{ pendingCount }}</span>
        <span>In Progress: {{ inProgressCount }}</span>
        <span>Completed: {{ completedCount }}</span>
      </div>

      <!-- ADD ACTION -->
      <div class="add-action-row" *ngIf="!isViewOnly">
        <mat-form-field appearance="outline">
          <mat-label>Sub Action</mat-label>
          <input matInput placeholder="Enter sub-action" [(ngModel)]="newActionText">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Due Date</mat-label>
          <input matInput [matDatepicker]="subDuePicker" [(ngModel)]="newSubActionDueDate">
          <mat-datepicker-toggle matSuffix [for]="subDuePicker"></mat-datepicker-toggle>
          <mat-datepicker #subDuePicker></mat-datepicker>
        </mat-form-field>
        
        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="newSubActionStatus">
            <mat-option value="Pending">Pending</mat-option>
            <mat-option value="In Progress">In Progress</mat-option>
            <mat-option value="Completed">Completed</mat-option>
          </mat-select>
        </mat-form-field>

        <app-common-button
          label="Add Action"
          title="Add Action"
          icon="fas fa-plus-circle"
          [buttonId]="1111"
          (clicked)="addSubAction()">
        </app-common-button>
      </div>

      <!-- AG GRID WITH PAGINATION -->
      <ag-grid-angular
        class="ag-theme-balham"
        style="width:100%; height:300px;"
        [components]="components"
        [rowData]="subActions"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [pagination]="true"
        [paginationPageSize]="paginationPageSize"
        rowSelection="single"
        (gridReady)="onGridReady($event)">
      </ag-grid-angular>

    </div>
  </mat-tab>

<!-- ================= ATTACHMENTS / LINKS ================= -->
<mat-tab label="Attachments / Links">
  <div class="card">
    <!-- ACTION BUTTONS SECTION -->
    <div class="attachment-actions">
      <!-- Upload Row -->
      <div class="form-row">
        <div class="form-label">Upload attachments :</div>
        <div >
         <div class="upload-wrapper" *ngIf="!isViewOnly"> 
          <input #fileInput type="file" hidden multiple (change)="onFileSelected($event)"> 
          <app-common-button label="Upload File" title="Upload File" icon="fas fa-upload" [buttonId]="1111" width="150px" (clicked)="fileInput.click()"> </app-common-button>
            <span class="file-hint">Supported: Any file type</span>
          </div>
        </div>
      </div>

      <!-- Link Row -->
      <div class="form-row">
        <div class="form-label">Add link :</div>
        <div style="display: flex;  gap: 8px;" *ngIf="!isViewOnly">
          <mat-form-field appearance="outline" class="link-input"> <mat-label>Add Link</mat-label> <input matInput [(ngModel)]="newLink" placeholder="https://example.com"> <mat-icon matSuffix>link</mat-icon> </mat-form-field>
          <app-common-button label="Add Link" title="Add Link" icon="fas fa-link" [buttonId]="1111" width="150px" (clicked)="addLink()" [disabled]="!newLink"> </app-common-button>
        </div>
      </div>
    </div>

    <!-- AG Grid -->
    <ag-grid-angular
      class="ag-theme-balham attachments-grid"
      style="width:100%; height:400px;"
      [components]="components"
      [rowData]="combinedAttachments"
      [columnDefs]="attColumnDefs"
      [defaultColDef]="defaultColDef"
      [pagination]="true"
      [paginationPageSize]="paginationPageSize"
      (gridReady)="onAttGridReady($event)">
    </ag-grid-angular>
  </div>
</mat-tab>
  
</mat-tab-group>

<!-- Edit Sub-Action Dialog -->
<div class="dialog-overlay" *ngIf="showEditDialog">
  <div class="dialog-container">
    <div class="dialog-header">
      <h2>Edit Sub-Action</h2>
      <button mat-icon-button (click)="closeEditDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    
    <div class="dialog-body">
      <form [formGroup]="editSubActionForm">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Action Name</mat-label>
          <input matInput formControlName="actionName">
          <mat-error *ngIf="editSubActionForm.get('actionName')?.hasError('required')">
            Action name is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Due Date</mat-label>
          <input matInput [matDatepicker]="editDuePicker" formControlName="dueDate">
          <mat-datepicker-toggle matSuffix [for]="editDuePicker"></mat-datepicker-toggle>
          <mat-datepicker #editDuePicker></mat-datepicker>
          <mat-error *ngIf="editSubActionForm.get('dueDate')?.hasError('required')">
            Due date is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option value="Pending">Pending</mat-option>
            <mat-option value="In Progress">In Progress</mat-option>
            <mat-option value="Completed">Completed</mat-option>
          </mat-select>
          <mat-error *ngIf="editSubActionForm.get('status')?.hasError('required')">
            Status is required
          </mat-error>
        </mat-form-field>
      </form>
    </div>
    
    <div class="dialog-footer">
      <app-common-button
        label="Cancel"
        title="Cancel"
        [buttonId]="1111"
        height="25px"
        (clicked)="closeEditDialog()"
        style="margin-right:1%">
      </app-common-button>
      <app-common-button
        label="Save Changes"
        title="Save Changes"
        [buttonId]="1111"
        height="25px"
        (clicked)="saveEditedSubAction()"
        [disabled]="editSubActionForm.invalid"
        style="margin-right:1%">
      </app-common-button>
    </div>
  </div>
</div>